import { render } from "./RequestSupport.vue?vue&type=template&id=28e33e70&ts=true"
import script from "./RequestSupport.vue?vue&type=script&lang=ts"
export * from "./RequestSupport.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Authentication/RequestSupport/RequestSupport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28e33e70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28e33e70', __exports__)) {
    api.reload('28e33e70', __exports__)
  }
  
  module.hot.accept("./RequestSupport.vue?vue&type=template&id=28e33e70&ts=true", () => {
    api.rerender('28e33e70', render)
  })

}


export default __exports__